// Service for employee contract list operations
import { apiClient, API_CONFIG } from '../../../core';
import type { ApiResponse } from '../../../shared';
import { buildQueryString } from '../../../shared';
import type {
  EmployeeContractListParams,
  EmployeeContractsPage,
  LC_GetEmployeeContractsOutLC_PagedResult,
} from '../types';
import { mapPagedContracts } from '../mappers';


export class EmployeeContractListService {
  async list(params: EmployeeContractListParams): Promise<ApiResponse<EmployeeContractsPage>> {
    const endpoint = API_CONFIG.ENDPOINTS.EMPLOYEE_CONTRACT.LIST(params.employeeId);
    const queryString = buildQueryString({
      page: params.page,
      pageSize: params.pageSize,
      searchText: params.searchText,
      contractStatusFilter: params.contractStatusFilter,
      orderBy: params.sort?.key,
      orderDirection: params.sort?.direction?.toUpperCase(),
    });
    const url = `${endpoint}${queryString}`;

    if (import.meta.env.VITE_API_DEBUG === 'true') {
      // eslint-disable-next-line no-console
      console.debug('[employeeContractListService.list] GET', url);
    }

    const response = await apiClient.get<LC_GetEmployeeContractsOutLC_PagedResult>(url);

    if (!response.success || !response.data) return { ...response, data: null };

    try {
      const mapped = mapPagedContracts(response.data);
      return { ...response, data: mapped };
    } catch (error) {
      if (import.meta.env.VITE_API_DEBUG === 'true') {
        // eslint-disable-next-line no-console
        console.error('[employeeContractListService.list] Mapping error:', error);
      }
      return { ...response, data: null, success: false };
    }
  }
}

export const employeeContractListService = new EmployeeContractListService();
